// consoleLogger.js

(function () {
  const DB_NAME = "WinnerDebugDB";
  const STORE_NAME = "logs";
  let db;

  /* ---------------- INITIALIZE INDEXEDDB ---------------- */
  const initDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, 1);
      request.onupgradeneeded = (e) => {
        const dbReq = e.target.result;
        if (!dbReq.objectStoreNames.contains(STORE_NAME)) {
          dbReq.createObjectStore(STORE_NAME, {
            keyPath: "id",
            autoIncrement: true,
          });
        }
      };
      request.onsuccess = (e) => {
        db = e.target.result;
        resolve(db);
      };
      request.onerror = (e) => reject(e.target.error);
    });
  };

  /* ---------------- DEDUPLICATION STATE ---------------- */
  let lastLogMessage = "";
  let lastLogType = "";
  let lastLogTimestamp = 0;
  const DUPLICATE_THRESHOLD = 10000; // 10 seconds

  /* ---------------- STORE LOG IN INDEXEDDB ---------------- */
  async function storeLog(type, args) {
    if (!db) await initDB();

    const serializedMessage = args
      .map((a) => {
        if (typeof a === "object") {
          try {
            return JSON.stringify(a);
          } catch {
            return "[object Object]";
          }
        }
        return String(a);
      })
      .join(" ");

    const now = Date.now();

    // Deduplication Logic:
    // Skip if (same message AND same type) AND (less than 10 seconds passed)
    if (
      serializedMessage === lastLogMessage &&
      type === lastLogType &&
      now - lastLogTimestamp < DUPLICATE_THRESHOLD
    ) {
      return;
    }

    lastLogMessage = serializedMessage;
    lastLogType = type;
    lastLogTimestamp = now;

    const logEntry = {
      time: new Date().toLocaleString(),
      type: type,
      message: serializedMessage,
    };

    const transaction = db.transaction([STORE_NAME], "readwrite");
    const store = transaction.objectStore(STORE_NAME);
    store.add(logEntry);
  }

  /* ---------------- GET ALL LOGS AS TEXT ---------------- */
  window.getLogsAsText = async () => {
    if (!db) await initDB();
    return new Promise((resolve) => {
      const transaction = db.transaction([STORE_NAME], "readonly");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.getAll();
      request.onsuccess = () => {
        const text = request.result
          .map(
            (log) => `[${log.time}] [${log.type.toUpperCase()}] ${log.message}`,
          )
          .join("\n");
        resolve(text);
      };
    });
  };

  /* ---------------- SYNC/EXPORT LOGS TO SERVER VIA API ---------------- */
  window.getLogFile = async () => {
    try {
      const logText = await window.getLogsAsText();
      if (!logText) {
        //         // console.log("[ConsoleLogger] No logs to sync.");
        return;
      }
      return new Blob([logText], { type: "text/plain" });
    } catch (error) {
      console.error("[ConsoleLogger] Error during log sync:", error);
    }
  };

  /* ---------------- DOWNLOAD FOR MANUAL CHECK ---------------- */
  window.downloadLogs = async () => {
    const text = await window.getLogsAsText();
    const blob = new Blob([text], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `live_debug_logs_${Date.now()}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  /* ---------------- DOWNLOAD LOG FILE VIA LINK (SERVER) ---------------- */
  window.downloadLogViaLink = (url) => {
    if (!url) return;
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank"; // Open in new tab if browser doesn't force download
    // Use the filename from the URL or a default one
    const filename = url.split("/").pop() || `server_log_${Date.now()}.txt`;
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  /* ---------------- OVERRIDE CONSOLE ---------------- */
  const originalLog = console.log;
  const originalError = console.error;
  const originalWarn = console.warn;

  console.log = (...args) => {
    storeLog("log", args);
    originalLog.apply(console, args);
  };

  console.error = (...args) => {
    storeLog("error", args);
    originalError.apply(console, args);
  };

  console.warn = (...args) => {
    storeLog("warn", args);
    originalWarn.apply(console, args);
  };

  /* ---------------- CLEAR ALL LOGS ---------------- */
  window.clearLogs = () => {
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], "readwrite");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.clear();
      request.onsuccess = () => {
        //         // console.log("[ConsoleLogger] DB Cleared.");
        resolve();
      };
      request.onerror = (e) => reject(e.target.error);
    });
  };

  // Initial DB load
  initDB().catch((err) =>
    originalError.apply(console, ["[ConsoleLogger] DB Init Failed", err]),
  );
})();
